import React, { Dispatch, SetStateAction } from "react"
import dayjs from "dayjs"
import { useQuery } from "@apollo/client"
import { useAppDispatch } from "lib/store"
import { showEditSidebar } from "lib/store/services/editSidebar/slice"

import GET_KUSTOM_CONFIG from "graphql/queries/config/GetKustomCheckoutConfig"

import { Name, Id } from "components/Ui/Table/Shared.styled"

import TableRow from "../../Ui/Table/TableRow"
import { BlurRow } from "../../Ui/Table/TableBlurLoading"

import { ReactComponent as KlarnaIcon } from "images/providers/icons/klarna.svg"
import { ReactComponent as KustomIcon } from "images/providers/icons/kustom.svg"

export const getLoadingRow = () => (
  <>
    <KustomIcon />
    <div>
      <div>
        <Name>Merchant ID</Name>
        <Id>Merchant ID</Id>
      </div>
    </div>
    <div className="hideOnSmallScreens">
      <p>https://baseurl.se</p>
    </div>
    <div className="hideOnSmallScreens hideOnMediumScreens">
      <p>2000-00-00</p>
    </div>
    <div className="hideOnSmallScreens hideOnMediumScreens">
      <p>2000-00-00</p>
    </div>
  </>
)

type Props = {
  id: string
  setEditId?: Dispatch<SetStateAction<string>>
}

export const KustomCheckoutConfigTableRow = ({ id, setEditId }: Props) => {
  const dispatch = useAppDispatch()

  const { data, loading } = useQuery(GET_KUSTOM_CONFIG, {
    variables: { id: id }
  })

  const kustomConfig = data?.getKlarnaCheckoutConfig

  const klarnaUrl = kustomConfig?.baseUrl?.includes("klarna")

  if (loading) return <BlurRow>{getLoadingRow()}</BlurRow>

  return (
    <TableRow
      key={id}
      handleOnClick={() => {
        if (setEditId) setEditId(kustomConfig.id)
        dispatch(showEditSidebar())
      }}
    >
      {klarnaUrl ? <KlarnaIcon /> : <KustomIcon/>}
      <div>
        <div>
          <Name>{kustomConfig?.merchantId}</Name>
          <Id>{kustomConfig?.id}</Id>
        </div>
      </div>
      <div className="hideOnSmallScreens">
        <p>{kustomConfig?.baseUrl}</p>
      </div>
      <div className="hideOnSmallScreens hideOnMediumScreens">
        <p>{dayjs(kustomConfig?.created).format("YYYY-MM-DD")}</p>
      </div>
      <div className="hideOnSmallScreens hideOnMediumScreens">
        <p>{dayjs(kustomConfig?.updated).format("YYYY-MM-DD")}</p>
      </div>
    </TableRow>
  )
}
